export const idlFactory = ({ IDL }) => {
	const Result_9 = IDL.Variant({ 'ok': IDL.Null, 'err': IDL.Text });
	const Time = IDL.Int;
	const PoolSourceType = IDL.Variant({
		'VerificationFee': IDL.Record({
			'feePerTicket': IDL.Nat,
			'contributionRate': IDL.Nat,
		}),
		'ManualInject': IDL.Null,
		'MarketFee': IDL.Null,
		'RefreshFee': IDL.Null,
	});
	const DynamicPoolSnapshot = IDL.Record({
		'totalDistributed': IDL.Nat,
		'createdAt': Time,
		'totalContributions': IDL.Nat,
		'contributorCount': IDL.Nat,
		'sourceType': PoolSourceType,
		'enabled': IDL.Bool,
		'accumulatedAmount': IDL.Nat,
		'baseAmount': IDL.Nat,
		'lastUpdateAt': Time,
	});
	const ReplenishRecord = IDL.Record({
		'memo': IDL.Opt(IDL.Text),
		'operatorId': IDL.Principal,
		'timestamp': Time,
		'amount': IDL.Nat,
	});
	const TokenInfo = IDL.Record({
		'decimals': IDL.Nat8,
		'runeId': IDL.Text,
		'runeName': IDL.Text,
	});
	const PrizeType = IDL.Variant({
		'Rune': IDL.Record({ 'tokenInfo': TokenInfo, 'amount': IDL.Nat }),
		'Ticket': IDL.Nat,
		'Balance': IDL.Nat,
	});
	const PrizeView = IDL.Record({
		'id': IDL.Nat,
		'remainingStock': IDL.Nat,
		'threshold': IDL.Nat,
		'name': IDL.Text,
		'maxWinsPerUser': IDL.Nat,
		'dynamicPool': IDL.Opt(DynamicPoolSnapshot),
		'level': IDL.Nat,
		'replenishHistory': IDL.Vec(ReplenishRecord),
		'totalStock': IDL.Nat,
		'roundId': IDL.Nat,
		'lastReplenishTime': IDL.Opt(Time),
		'prizeType': PrizeType,
	});
	const Result_5 = IDL.Variant({ 'ok': PrizeView, 'err': IDL.Text });
	const Result_12 = IDL.Variant({ 'ok': IDL.Vec(IDL.Text), 'err': IDL.Text });
	const Result = IDL.Variant({ 'ok': IDL.Nat, 'err': IDL.Text });
	const Result_21 = IDL.Variant({
		'ok': IDL.Record({
			'deletedCount': IDL.Nat,
			'processedCount': IDL.Nat,
			'completed': IDL.Bool,
			'remainingEstimate': IDL.Nat,
		}),
		'err': IDL.Text,
	});
	const Result_20 = IDL.Variant({
		'ok': IDL.Record({
			'deletedCount': IDL.Nat,
			'roundName': IDL.Text,
			'roundId': IDL.Nat,
		}),
		'err': IDL.Text,
	});
	const PointsDividendConfig = IDL.Record({
		'minDividendAmount': IDL.Nat,
		'createdAt': Time,
		'enabled': IDL.Bool,
		'updatedAt': Time,
		'lossShareRate': IDL.Nat,
		'roundId': IDL.Nat,
		'profitShareRate': IDL.Nat,
		'basePool': IDL.Nat,
	});
	const Result_19 = IDL.Variant({
		'ok': PointsDividendConfig,
		'err': IDL.Text,
	});
	const RoundStatus = IDL.Variant({
		'Paused': IDL.Null,
		'Active': IDL.Null,
		'Draft': IDL.Null,
		'Scheduled': IDL.Null,
		'GlobalLedger': IDL.Null,
		'Completed': IDL.Null,
	});
	const Round = IDL.Record({
		'id': IDL.Nat,
		'allowMarket': IDL.Bool,
		'startTime': IDL.Opt(Time),
		'status': RoundStatus,
		'prizeIds': IDL.Vec(IDL.Nat),
		'allowGrantedTicketRecycle': IDL.Bool,
		'recyclePeriodDays': IDL.Nat,
		'allowRefresh': IDL.Bool,
		'endTime': IDL.Opt(Time),
		'referralEnabled': IDL.Bool,
		'memo': IDL.Opt(IDL.Text),
		'name': IDL.Text,
		'createdAt': Time,
		'updatedAt': Time,
		'allowDraw': IDL.Bool,
		'recycleEnabled': IDL.Bool,
		'allowVerification': IDL.Bool,
	});
	const Result_4 = IDL.Variant({ 'ok': Round, 'err': IDL.Text });
	const DrawResult = IDL.Variant({
		'Win': IDL.Record({
			'prizeId': IDL.Nat,
			'recordId': IDL.Opt(IDL.Nat),
			'prizeName': IDL.Text,
			'prizeType': PrizeType,
		}),
		'NoWin': IDL.Record({ 'message': IDL.Text }),
	});
	const Result_18 = IDL.Variant({ 'ok': DrawResult, 'err': IDL.Text });
	const Result_17 = IDL.Variant({
		'ok': IDL.Vec(DrawResult),
		'err': IDL.Text,
	});
	const TicketRarity = IDL.Variant({
		'Epic': IDL.Null,
		'Rare': IDL.Null,
		'Uncommon': IDL.Null,
		'Legendary': IDL.Null,
		'Common': IDL.Null,
	});
	const PointsExchange = IDL.Record({
		'winProbability': IDL.Nat,
		'bonusPoints': IDL.Nat,
		'ticketId': IDL.Text,
		'ticketRarity': TicketRarity,
		'timestamp': Time,
		'ticketLevelParam': IDL.Nat,
		'totalPoints': IDL.Nat,
		'basePoints': IDL.Nat,
	});
	const Result_16 = IDL.Variant({
		'ok': IDL.Vec(PointsExchange),
		'err': IDL.Text,
	});
	const PreviewStatus = IDL.Variant({
		'RoundEnded': IDL.Null,
		'Cancelled': IDL.Null,
		'InProgress': IDL.Null,
		'Settled': IDL.Null,
	});
	const DividendPreview = IDL.Record({
		'status': PreviewStatus,
		'queryTime': Time,
		'currentTotalPool': IDL.Int,
		'canDividend': IDL.Bool,
		'roundName': IDL.Text,
		'roundId': IDL.Nat,
		'currentBonusPool': IDL.Int,
		'currentProfit': IDL.Int,
		'participantCount': IDL.Nat,
		'totalPoints': IDL.Nat,
		'config': PointsDividendConfig,
		'estimatedDividendPerPoint': IDL.Float64,
		'currentBasePool': IDL.Nat,
	});
	const Result_15 = IDL.Variant({ 'ok': DividendPreview, 'err': IDL.Text });
	const PendingDividend = IDL.Record({
		'user': IDL.Principal,
		'intendedAmount': IDL.Nat,
		'points': IDL.Nat,
		'reason': IDL.Text,
	});
	const DividendStatus = IDL.Variant({
		'Failed': IDL.Text,
		'Cancelled': IDL.Null,
		'Settled': IDL.Null,
		'Pending': IDL.Null,
	});
	const UserDividend = IDL.Record({
		'pointsRatio': IDL.Float64,
		'calculatedAmount': IDL.Float64,
		'txId': IDL.Nat,
		'user': IDL.Principal,
		'actualAmount': IDL.Nat,
		'points': IDL.Nat,
	});
	const DividendSettlementReport = IDL.Record({
		'pendingDividends': IDL.Vec(PendingDividend),
		'dividendPerPoint': IDL.Float64,
		'status': DividendStatus,
		'totalPendingAmount': IDL.Nat,
		'actualDividendPool': IDL.Nat,
		'settlementTime': Time,
		'memo': IDL.Opt(IDL.Text),
		'dividendRecords': IDL.Vec(UserDividend),
		'totalDividendPaid': IDL.Nat,
		'finalTotalPool': IDL.Int,
		'roundName': IDL.Text,
		'roundId': IDL.Nat,
		'finalBonusPool': IDL.Int,
		'participantCount': IDL.Nat,
		'totalPoints': IDL.Nat,
		'finalBasePool': IDL.Nat,
		'finalProfit': IDL.Int,
	});
	const Result_14 = IDL.Variant({
		'ok': IDL.Record({
			'totalDistributed': IDL.Nat,
			'totalContributions': IDL.Nat,
			'contributorCount': IDL.Nat,
			'accumulatedAmount': IDL.Nat,
			'baseAmount': IDL.Nat,
			'prize': PrizeView,
			'currentRewardPerUnit': IDL.Nat,
		}),
		'err': IDL.Text,
	});
	const StatisticsQueryScope = IDL.Variant({
		'ActiveRound': IDL.Null,
		'ByRound': IDL.Nat,
		'Global': IDL.Null,
	});
	const FinancialFlowStats = IDL.Record({
		'dynamicPoolLiability': IDL.Nat,
		'netCashFlow': IDL.Int,
		'totalWithdrawn': IDL.Nat,
		'userBalanceLiability': IDL.Nat,
		'platformReserveBalance': IDL.Int,
		'totalDeposited': IDL.Nat,
	});
	const FinancialLiabilityBreakdown = IDL.Record({
		'total': IDL.Nat,
		'runePrizesIssued': IDL.Nat,
		'ticketPrizeLiability': IDL.Nat,
		'unusedTicketLiability': IDL.Nat,
	});
	const FinancialRevenueBreakdown = IDL.Record({
		'marketFees': IDL.Nat,
		'verifyFees': IDL.Nat,
		'total': IDL.Nat,
		'refreshFees': IDL.Nat,
		'ticketSales': IDL.Nat,
		'withdrawFees': IDL.Nat,
	});
	const FinancialReferralStats = IDL.Record({
		'level1CommissionPaid': IDL.Nat,
		'boundUsers': IDL.Nat,
		'commissionPaid': IDL.Nat,
		'unboundUsers': IDL.Nat,
		'level2CommissionPaid': IDL.Nat,
	});
	const FinancialCashBreakdown = IDL.Record({
		'total': IDL.Nat,
		'referralCommission': IDL.Nat,
		'cashPrizes': IDL.Nat,
		'pointsDividend': IDL.Nat,
		'ticketRecycle': IDL.Nat,
	});
	const FinancialProfitMetrics = IDL.Record({
		'realProfitMargin': IDL.Float64,
		'netProfitAfterLiability': IDL.Int,
		'profitMargin': IDL.Float64,
		'netProfit': IDL.Int,
	});
	const FinancialSummary = IDL.Record({
		'marketFees': IDL.Nat,
		'flows': FinancialFlowStats,
		'verifyFees': IDL.Nat,
		'liabilities': FinancialLiabilityBreakdown,
		'revenue': FinancialRevenueBreakdown,
		'referral': FinancialReferralStats,
		'refreshFees': IDL.Nat,
		'cash': FinancialCashBreakdown,
		'realProfitMargin': IDL.Float64,
		'referralBoundUsers': IDL.Nat,
		'referralUnboundUsers': IDL.Nat,
		'netProfitAfterLiability': IDL.Int,
		'unusedTicketCount': IDL.Nat,
		'ticketLiability': IDL.Nat,
		'ticketSales': IDL.Nat,
		'withdrawFees': IDL.Nat,
		'netCashFlow': IDL.Int,
		'totalWithdrawn': IDL.Nat,
		'prizes': IDL.Nat,
		'profit': FinancialProfitMetrics,
		'userBalanceLiability': IDL.Nat,
		'totalRevenue': IDL.Nat,
		'platformReserveBalance': IDL.Int,
		'pointsDividend': IDL.Nat,
		'totalExpense': IDL.Nat,
		'profitMargin': IDL.Float64,
		'totalDeposited': IDL.Nat,
		'netProfit': IDL.Int,
		'referralCommissionPaid': IDL.Nat,
	});
	const UserReferralInfo = IDL.Record({
		'referralCode': IDL.Text,
		'totalCommission': IDL.Nat,
		'totalReferrals': IDL.Nat,
		'user': IDL.Principal,
		'level2Commission': IDL.Nat,
		'referredBy': IDL.Opt(IDL.Text),
		'level2Referrals': IDL.Nat,
		'bindTime': IDL.Opt(Time),
		'level1Commission': IDL.Nat,
		'level1Referrals': IDL.Nat,
	});
	const OrderStatus = IDL.Variant({
		'Sold': IDL.Null,
		'Active': IDL.Null,
		'Cancelled': IDL.Null,
		'Expired': IDL.Null,
	});
	const ListingStatus = IDL.Variant({
		'Sold': IDL.Null,
		'Active': IDL.Null,
		'Cancelled': IDL.Null,
	});
	const MarketListing = IDL.Record({
		'status': ListingStatus,
		'listTime': Time,
		'price': IDL.Nat,
	});
	const DrawRecord = IDL.Record({
		'drawTime': Time,
		'prizeId': IDL.Opt(IDL.Nat),
		'roundId': IDL.Nat,
		'ticketLevelParam': IDL.Opt(IDL.Nat),
		'randomSeed': IDL.Text,
		'isWin': IDL.Bool,
		'amount': IDL.Opt(IDL.Nat),
		'prizeName': IDL.Opt(IDL.Text),
	});
	const TicketStatus = IDL.Variant({
		'Available': IDL.Null,
		'Listed': MarketListing,
		'Used': DrawRecord,
		'Unverified': IDL.Null,
	});
	const Platform = IDL.Variant({ 'Odin': IDL.Null, 'Fomowell': IDL.Null });
	const TicketSource = IDL.Variant({
		'UserPurchase': IDL.Record({
			'txId': IDL.Nat,
			'buyer': IDL.Principal,
			'amount': IDL.Nat,
		}),
		'RuneExchange': IDL.Record({
			'platform': Platform,
			'operationId': IDL.Nat,
			'tokenInfo': TokenInfo,
			'amount': IDL.Nat,
		}),
		'AdminGrant': IDL.Record({
			'admin': IDL.Principal,
			'batchId': IDL.Opt(IDL.Text),
			'reason': IDL.Text,
		}),
	});
	const Ticket = IDL.Record({
		'id': IDL.Text,
		'source': TicketSource,
		'owner': IDL.Principal,
		'createTime': Time,
		'roundId': IDL.Nat,
		'isVerified': IDL.Bool,
	});
	const VerifiedTicketData = IDL.Record({
		'verifyTime': Time,
		'winProbability': IDL.Nat,
		'refreshCount': IDL.Nat,
		'ticketLevelParam': IDL.Nat,
		'lastRefreshTime': IDL.Opt(Time),
	});
	const TicketInfo = IDL.Record({
		'status': TicketStatus,
		'ticket': Ticket,
		'verifiedData': IDL.Opt(VerifiedTicketData),
	});
	const MarketOrder = IDL.Record({
		'status': OrderStatus,
		'createTime': Time,
		'seller': IDL.Principal,
		'ticketId': IDL.Text,
		'orderId': IDL.Nat,
		'ticketInfo': TicketInfo,
		'price': IDL.Nat,
	});
	const PoolContributionRecord = IDL.Record({
		'source': IDL.Text,
		'timestamp': Time,
		'amount': IDL.Nat,
		'contributor': IDL.Opt(IDL.Principal),
	});
	const PoolDistributionRecord = IDL.Record({
		'winner': IDL.Principal,
		'prizeId': IDL.Nat,
		'totalAmount': IDL.Nat,
		'timestamp': Time,
		'baseAmount': IDL.Nat,
		'prizeName': IDL.Text,
		'dynamicAmount': IDL.Nat,
	});
	const RoundSettlementStats = IDL.Record({
		'status': RoundStatus,
		'listingsCount': IDL.Nat,
		'recyclableTickets': IDL.Nat,
		'isSettled': IDL.Bool,
		'estimatedBatches': IDL.Nat,
		'roundName': IDL.Text,
		'roundId': IDL.Nat,
		'suggestedBatchSize': IDL.Nat,
		'usedTickets': IDL.Nat,
		'remainingToSettle': IDL.Nat,
		'totalTickets': IDL.Nat,
	});
	const Result_13 = IDL.Variant({
		'ok': RoundSettlementStats,
		'err': IDL.Text,
	});
	const RoundQueryFilter = IDL.Variant({
		'All': IDL.Null,
		'Active': IDL.Null,
		'ByIds': IDL.Vec(IDL.Nat),
		'ByStatus': RoundStatus,
	});
	const SystemConfigType = IDL.Variant({
		'All': IDL.Null,
		'Recycle': IDL.Null,
		'Financial': IDL.Null,
		'Token': IDL.Opt(IDL.Text),
		'Verification': IDL.Null,
		'Refresh': IDL.Null,
		'Lottery': IDL.Null,
		'Market': IDL.Null,
		'Referral': IDL.Null,
	});
	const LotteryConfig = IDL.Record({ 'baseProbability': IDL.Nat });
	const ReferralBindingPolicy = IDL.Variant({
		'OneTime': IDL.Null,
		'Limited': IDL.Nat,
	});
	const ReferralConfig = IDL.Record({
		'bindingPolicy': ReferralBindingPolicy,
		'enabled': IDL.Bool,
		'commissionRates': IDL.Vec(IDL.Nat),
	});
	const RecycleConfig = IDL.Record({
		'recycleRateByLevel': IDL.Vec(IDL.Tuple(IDL.Nat, IDL.Nat, IDL.Nat)),
		'recycleRateUnverified': IDL.Nat,
		'defaultRecycleEnabled': IDL.Bool,
		'defaultAllowGrantedRecycle': IDL.Bool,
		'defaultRecyclePeriodDays': IDL.Nat,
	});
	const TokenConfig = IDL.Record({
		'decimals': IDL.Nat8,
		'tokenId': IDL.Text,
		'enabled': IDL.Bool,
		'balancePerToken': IDL.Nat,
		'tokenName': IDL.Text,
		'minDepositAmount': IDL.Nat,
	});
	const MarketConfig = IDL.Record({
		'feeRate': IDL.Nat,
		'maxPrice': IDL.Nat,
		'minPrice': IDL.Nat,
	});
	const FinancialConfig = IDL.Record({
		'withdrawFeeRate': IDL.Nat,
		'ticketPrice': IDL.Nat,
	});
	const ProbabilityDistribution = IDL.Record({
		'ranges': IDL.Vec(IDL.Tuple(IDL.Nat, IDL.Nat, IDL.Nat)),
	});
	const VerificationConfig = IDL.Record({
		'levelProbabilityDistribution': ProbabilityDistribution,
		'winProbabilityDistribution': ProbabilityDistribution,
		'verificationFee': IDL.Nat,
	});
	const RefreshConfig = IDL.Record({
		'maxWinProbability': IDL.Nat,
		'maxRefreshCount': IDL.Nat,
		'degradeProbability': IDL.Float64,
		'levelParamIncrementMax': IDL.Nat,
		'levelParamIncrementMin': IDL.Nat,
		'degradeAmount': IDL.Nat,
		'costMultiplier': IDL.Float64,
		'maxLevelParameter': IDL.Nat,
		'winProbIncrementMax': IDL.Nat,
		'winProbIncrementMin': IDL.Nat,
		'baseCost': IDL.Nat,
	});
	const SystemConfigResponse = IDL.Record({
		'lottery': IDL.Opt(LotteryConfig),
		'referral': IDL.Opt(ReferralConfig),
		'recycle': IDL.Opt(RecycleConfig),
		'tokens': IDL.Vec(IDL.Tuple(IDL.Text, TokenConfig)),
		'market': IDL.Opt(MarketConfig),
		'financial': IDL.Opt(FinancialConfig),
		'verification': IDL.Opt(VerificationConfig),
		'refresh': IDL.Opt(RefreshConfig),
	});
	const LotteryStatus = IDL.Variant({
		'Stopped': IDL.Null,
		'Paused': IDL.Null,
		'Active': IDL.Null,
	});
	const SystemControls = IDL.Record({
		'lotteryStatus': LotteryStatus,
		'withdrawEnabled': IDL.Bool,
		'verificationEnabled': IDL.Bool,
		'depositEnabled': IDL.Bool,
		'allowWithdrawDuringPause': IDL.Bool,
		'drawEnabled': IDL.Bool,
		'marketEnabled': IDL.Bool,
		'ticketPurchaseEnabled': IDL.Bool,
		'refreshEnabled': IDL.Bool,
	});
	const PrizeStats = IDL.Record({
		'totalClaimed': IDL.Nat,
		'totalDistributed': IDL.Nat,
		'totalWins': IDL.Nat,
		'prizeId': IDL.Nat,
	});
	const LotteryStats = IDL.Record({
		'totalTicketsUsed': IDL.Nat,
		'totalWins': IDL.Nat,
		'totalTicketsIssued': IDL.Nat,
		'prizeStats': IDL.Vec(IDL.Tuple(IDL.Nat, PrizeStats)),
		'totalDraws': IDL.Nat,
	});
	const TopUserData = IDL.Record({
		'principal': IDL.Principal,
		'value': IDL.Nat,
		'rank': IDL.Nat,
	});
	const UserBalance = IDL.Record({
		'principal': IDL.Principal,
		'balance': IDL.Nat,
		'lastUpdate': Time,
		'totalSpent': IDL.Nat,
		'totalWithdrawn': IDL.Nat,
		'totalDeposited': IDL.Nat,
	});
	const UserDividendRecord = IDL.Record({
		'dividendAmount': IDL.Nat,
		'settlementTime': Time,
		'txId': IDL.Nat,
		'roundName': IDL.Text,
		'roundId': IDL.Nat,
		'points': IDL.Nat,
	});
	const UserDividendHistory = IDL.Record({
		'totalDividendReceived': IDL.Nat,
		'records': IDL.Vec(UserDividendRecord),
		'roundsParticipated': IDL.Nat,
		'user': IDL.Principal,
	});
	const TicketFilter = IDL.Record({
		'status': IDL.Opt(TicketStatus),
		'verified': IDL.Opt(IDL.Bool),
	});
	const WithdrawStatus = IDL.Record({
		'maxCount24h': IDL.Nat,
		'user': IDL.Principal,
		'used24h': IDL.Nat,
		'maxPerTx': IDL.Nat,
		'windowStart': Time,
		'windowEnd': Time,
		'usedCount24h': IDL.Nat,
		'remainingCount24h': IDL.Nat,
		'max24h': IDL.Nat,
		'remaining24h': IDL.Nat,
		'lastWithdrawTime': IDL.Opt(Time),
	});
	const RoundManageAction = IDL.Variant({
		'SetStatus': RoundStatus,
		'SetActive': IDL.Null,
		'SetInactive': IDL.Null,
	});
	const ProcessedTransfer = IDL.Record({
		'userId': IDL.Principal,
		'platform': Platform,
		'processTime': Time,
		'operationId': IDL.Nat,
		'tokenInfo': TokenInfo,
		'balanceAdded': IDL.Nat,
		'amount': IDL.Nat,
	});
	const Result_11 = IDL.Variant({ 'ok': ProcessedTransfer, 'err': IDL.Text });
	const MarketQueryScope = IDL.Variant({
		'BySeller': IDL.Principal,
		'ByRound': IDL.Nat,
		'Global': IDL.Null,
	});
	const MarketFilterV2 = IDL.Record({
		'status': IDL.Opt(OrderStatus),
		'maxWinProb': IDL.Opt(IDL.Nat),
		'maxPrice': IDL.Opt(IDL.Nat),
		'maxLevelParam': IDL.Opt(IDL.Nat),
		'minLevelParam': IDL.Opt(IDL.Nat),
		'minWinProb': IDL.Opt(IDL.Nat),
		'minPrice': IDL.Opt(IDL.Nat),
	});
	const Direction = IDL.Variant({
		'Backward': IDL.Null,
		'Forward': IDL.Null,
	});
	const CursorType = IDL.Variant({ 'Nat': IDL.Nat, 'Text': IDL.Text });
	const PaginatedResult_4 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(MarketOrder),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const CommissionQueryScope = IDL.Variant({
		'ByReferee': IDL.Principal,
		'ByLevel': IDL.Nat,
		'ByReferrerAndLevel': IDL.Tuple(IDL.Principal, IDL.Nat),
		'ByReferrer': IDL.Principal,
		'Global': IDL.Null,
	});
	const ReferralCommissionRecord = IDL.Record({
		'id': IDL.Nat,
		'referrer': IDL.Principal,
		'purchaseAmount': IDL.Nat,
		'level': IDL.Nat,
		'roundId': IDL.Nat,
		'timestamp': Time,
		'commissionAmount': IDL.Nat,
		'commissionRate': IDL.Nat,
		'referee': IDL.Principal,
		'relatedTxId': IDL.Nat,
	});
	const PaginatedResult_6 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(ReferralCommissionRecord),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const MarketFilter = IDL.Record({
		'maxWinProbability': IDL.Opt(IDL.Nat),
		'minWinProbability': IDL.Opt(IDL.Nat),
		'maxPrice': IDL.Opt(IDL.Nat),
		'maxPrizeLevel': IDL.Opt(IDL.Nat),
		'minPrizeLevel': IDL.Opt(IDL.Nat),
		'minPrice': IDL.Opt(IDL.Nat),
	});
	const OperationType = IDL.Variant({
		'Withdraw': IDL.Null,
		'GrantTicket': IDL.Null,
		'ExchangePoints': IDL.Null,
		'ReferralCommission': IDL.Null,
		'CancelListing': IDL.Null,
		'Deposit': IDL.Null,
		'DrawTicket': IDL.Null,
		'RefreshTicket': IDL.Null,
		'RecycleTicket': IDL.Null,
		'RuneExchange': IDL.Null,
		'ListTicket': IDL.Null,
		'DistributeDividend': IDL.Null,
		'BuyTicket': IDL.Null,
		'SettleRecycle': IDL.Null,
		'Admin': IDL.Null,
		'Transfer': IDL.Null,
		'Other': IDL.Null,
		'BindReferral': IDL.Null,
		'VerifyTicket': IDL.Null,
		'BuyFromMarket': IDL.Null,
		'ClaimPrize': IDL.Null,
	});
	const OperationQueryScope = IDL.Variant({
		'ByUserAndType': IDL.Record({
			'opType': OperationType,
			'user': IDL.Principal,
		}),
		'ByType': OperationType,
		'ByUser': IDL.Principal,
		'Global': IDL.Null,
	});
	const OperationStatus = IDL.Variant({
		'Failed': IDL.Text,
		'Success': IDL.Null,
		'Pending': IDL.Null,
	});
	const OperationDetails = IDL.Variant({
		'Withdraw': IDL.Record({
			'fee': IDL.Nat,
			'address': IDL.Text,
			'amount': IDL.Nat,
		}),
		'GrantTicket': IDL.Record({
			'recipient': IDL.Principal,
			'ticketIds': IDL.Vec(IDL.Text),
			'quantity': IDL.Nat,
			'reason': IDL.Text,
		}),
		'ExchangePoints': IDL.Record({
			'ticketIds': IDL.Vec(IDL.Text),
			'totalPoints': IDL.Nat,
			'exchangeCount': IDL.Nat,
		}),
		'ReferralCommission': IDL.Record({
			'rate': IDL.Nat,
			'amount': IDL.Nat,
			'referee': IDL.Principal,
		}),
		'CancelListing': IDL.Record({
			'ticketId': IDL.Text,
			'reason': IDL.Text,
		}),
		'Deposit': IDL.Record({ 'txId': IDL.Text, 'amount': IDL.Nat }),
		'DrawTicket': IDL.Record({ 'result': DrawResult, 'ticketId': IDL.Text }),
		'RefreshTicket': IDL.Record({
			'cost': IDL.Nat,
			'ticketId': IDL.Text,
			'newProb': IDL.Tuple(IDL.Nat, IDL.Nat),
			'oldProb': IDL.Tuple(IDL.Nat, IDL.Nat),
		}),
		'RecycleTicket': IDL.Record({
			'ticketId': IDL.Text,
			'recycleRate': IDL.Nat,
			'isVerified': IDL.Bool,
			'recycleAmount': IDL.Nat,
		}),
		'RuneExchange': IDL.Record({
			'platform': Platform,
			'operationId': IDL.Nat,
			'tokenInfo': TokenInfo,
			'balanceAdded': IDL.Nat,
			'amount': IDL.Nat,
		}),
		'ListTicket': IDL.Record({ 'ticketId': IDL.Text, 'price': IDL.Nat }),
		'DistributeDividend': IDL.Record({
			'dividendAmount': IDL.Nat,
			'txId': IDL.Nat,
			'roundId': IDL.Nat,
			'points': IDL.Nat,
		}),
		'BuyTicket': IDL.Record({
			'cost': IDL.Nat,
			'ticketIds': IDL.Vec(IDL.Text),
			'quantity': IDL.Nat,
		}),
		'SettleRecycle': IDL.Record({
			'ticketId': IDL.Text,
			'roundId': IDL.Nat,
			'isVerified': IDL.Bool,
			'recycleAmount': IDL.Nat,
		}),
		'Admin': IDL.Record({
			'action': IDL.Text,
			'target': IDL.Opt(IDL.Principal),
			'params': IDL.Text,
		}),
		'Transfer': IDL.Record({
			'to': IDL.Principal,
			'from': IDL.Principal,
			'tokenInfo': TokenInfo,
			'amount': IDL.Nat,
		}),
		'Other': IDL.Record({ 'message': IDL.Text }),
		'BindReferral': IDL.Record({
			'referralCode': IDL.Text,
			'referrer': IDL.Principal,
		}),
		'VerifyTicket': IDL.Record({
			'fee': IDL.Nat,
			'winProbability': IDL.Nat,
			'ticketId': IDL.Text,
			'prizeLevel': IDL.Nat,
		}),
		'BuyFromMarket': IDL.Record({
			'seller': IDL.Principal,
			'ticketId': IDL.Text,
			'price': IDL.Nat,
		}),
		'ClaimPrize': IDL.Record({
			'recordId': IDL.Nat,
			'tokenInfo': TokenInfo,
			'amount': IDL.Nat,
		}),
	});
	const OperationRecord = IDL.Record({
		'id': IDL.Nat,
		'status': OperationStatus,
		'operator': IDL.Principal,
		'memo': IDL.Opt(IDL.Text),
		'operationType': OperationType,
		'relatedIds': IDL.Vec(IDL.Text),
		'timestamp': Time,
		'details': OperationDetails,
	});
	const PaginatedResult_5 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(OperationRecord),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const PointsQueryScope = IDL.Variant({
		'ByUser': IDL.Record({
			'user': IDL.Principal,
			'roundId': IDL.Opt(IDL.Nat),
		}),
		'GlobalRanking': IDL.Record({ 'topN': IDL.Nat }),
		'ByRound': IDL.Record({ 'topN': IDL.Opt(IDL.Nat), 'roundId': IDL.Nat }),
	});
	const PointsRecordView = IDL.Record({
		'rank': IDL.Opt(IDL.Nat),
		'user': IDL.Principal,
		'lastUpdateTime': Time,
		'roundId': IDL.Nat,
		'totalPoints': IDL.Nat,
		'exchangeCount': IDL.Nat,
		'exchangeHistory': IDL.Opt(IDL.Vec(PointsExchange)),
	});
	const PointsQueryResponse = IDL.Record({
		'queryTime': Time,
		'totalCount': IDL.Nat,
		'results': IDL.Vec(PointsRecordView),
		'scope': PointsQueryScope,
	});
	const ReferralQueryScope = IDL.Variant({
		'ByReferrer': IDL.Principal,
		'ByUser': IDL.Principal,
		'Global': IDL.Null,
	});
	const PaginatedResult_3 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(UserReferralInfo),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const TransactionType = IDL.Variant({
		'SellToMarket': IDL.Null,
		'Withdraw': IDL.Null,
		'ReferralCommission': IDL.Null,
		'Deposit': IDL.Null,
		'TicketRecycle': IDL.Null,
		'MarketTransfer': IDL.Null,
		'PrizeReward': IDL.Null,
		'RefreshTicket': IDL.Null,
		'PointsDividend': IDL.Null,
		'WithdrawFee': IDL.Null,
		'BuyTicket': IDL.Null,
		'DepositRollback': IDL.Null,
		'VerifyTicket': IDL.Null,
		'BuyFromMarket': IDL.Null,
	});
	const TransactionQueryScope = IDL.Variant({
		'ActiveRound': IDL.Null,
		'ByUserAndType': IDL.Record({
			'user': IDL.Principal,
			'txType': TransactionType,
		}),
		'ByUserInRound': IDL.Record({
			'user': IDL.Principal,
			'roundId': IDL.Nat,
		}),
		'ByType': TransactionType,
		'ByUser': IDL.Principal,
		'ByRound': IDL.Nat,
		'Global': IDL.Null,
	});
	const BalanceTransaction = IDL.Record({
		'id': IDL.Nat,
		'fee': IDL.Nat,
		'user': IDL.Principal,
		'description': IDL.Text,
		'roundId': IDL.Nat,
		'timestamp': Time,
		'txType': TransactionType,
		'amount': IDL.Nat,
		'relatedId': IDL.Opt(IDL.Text),
	});
	const PaginatedResult_2 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(BalanceTransaction),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const BalanceQueryScope = IDL.Variant({
		'ByUser': IDL.Principal,
		'Global': IDL.Null,
	});
	const BalanceFilter = IDL.Record({
		'minDeposited': IDL.Opt(IDL.Nat),
		'hasBalance': IDL.Opt(IDL.Bool),
		'minBalance': IDL.Opt(IDL.Nat),
	});
	const PaginatedResult_1 = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(UserBalance),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const WinRecordQueryScope = IDL.Variant({
		'ByUser': IDL.Principal,
		'ByRoundAndUser': IDL.Record({
			'user': IDL.Principal,
			'roundId': IDL.Nat,
		}),
		'ByRound': IDL.Nat,
		'Global': IDL.Null,
	});
	const ClaimStatus = IDL.Variant({
		'Unclaimed': IDL.Null,
		'Claiming': IDL.Null,
		'Failed': IDL.Null,
		'Claimed': IDL.Null,
		'Expired': IDL.Null,
	});
	const WinRecordFilter = IDL.Record({
		'minAmount': IDL.Opt(IDL.Nat),
		'claimStatus': IDL.Opt(ClaimStatus),
		'rarity': IDL.Opt(TicketRarity),
		'prizeLevel': IDL.Opt(IDL.Nat),
	});
	const WinRecord = IDL.Record({
		'id': IDL.Nat,
		'userId': IDL.Principal,
		'claimStatus': ClaimStatus,
		'claimTime': IDL.Opt(Time),
		'prizeId': IDL.Nat,
		'transferId': IDL.Opt(IDL.Nat),
		'tokenInfo': IDL.Opt(TokenInfo),
		'prizeLevel': IDL.Nat,
		'amount': IDL.Nat,
		'winTime': Time,
		'errorMsg': IDL.Opt(IDL.Text),
		'prizeName': IDL.Text,
	});
	const PaginatedResult = IDL.Record({
		'hasMore': IDL.Bool,
		'prevCursor': IDL.Opt(CursorType),
		'data': IDL.Vec(WinRecord),
		'totalCount': IDL.Opt(IDL.Nat),
		'nextCursor': IDL.Opt(CursorType),
	});
	const Result_10 = IDL.Variant({
		'ok': IDL.Record({ 'recycleRate': IDL.Nat, 'recycleAmount': IDL.Nat }),
		'err': IDL.Text,
	});
	const Result_3 = IDL.Variant({ 'ok': TicketInfo, 'err': IDL.Text });
	const OperationAction = IDL.Variant({
		'Withdraw': IDL.Null,
		'Draw': IDL.Null,
		'Deposit': IDL.Null,
		'Verification': IDL.Null,
		'Refresh': IDL.Null,
		'Market': IDL.Null,
		'TicketPurchase': IDL.Null,
	});
	const Result_8 = IDL.Variant({
		'ok': DividendSettlementReport,
		'err': IDL.Text,
	});
	const DynamicPoolSettlement = IDL.Record({
		'snapshotTime': Time,
		'totalDistributed': IDL.Nat,
		'totalContributions': IDL.Nat,
		'contributorCount': IDL.Nat,
		'prizeId': IDL.Nat,
		'roundId': IDL.Nat,
		'accumulatedAmount': IDL.Nat,
		'baseAmount': IDL.Nat,
		'prizeName': IDL.Text,
	});
	const RoundSettlementReport = IDL.Record({
		'totalRecycleValue': IDL.Nat,
		'dynamicPoolBalance': IDL.Nat,
		'settlementTime': Time,
		'unverifiedTicketsValue': IDL.Nat,
		'verifiedTicketsRecycled': IDL.Nat,
		'dynamicPoolSnapshots': IDL.Vec(DynamicPoolSettlement),
		'unverifiedTicketsRecycled': IDL.Nat,
		'roundName': IDL.Text,
		'roundId': IDL.Nat,
		'totalTicketsRecycled': IDL.Nat,
		'verifiedTicketsValue': IDL.Nat,
		'totalRevenue': IDL.Nat,
		'totalExpense': IDL.Nat,
		'profitMargin': IDL.Float64,
		'listingsCancelled': IDL.Nat,
		'netProfit': IDL.Int,
		'remainingPrizes': IDL.Nat,
	});
	const Result_7 = IDL.Variant({
		'ok': RoundSettlementReport,
		'err': IDL.Text,
	});
	const RoundSettlementBatchReport = IDL.Record({
		'processedCount': IDL.Nat,
		'totalRecycleValue': IDL.Nat,
		'unverifiedTicketsValue': IDL.Nat,
		'completed': IDL.Bool,
		'verifiedTicketsRecycled': IDL.Nat,
		'unverifiedTicketsRecycled': IDL.Nat,
		'settledCount': IDL.Nat,
		'roundName': IDL.Text,
		'remainingEstimate': IDL.Nat,
		'roundId': IDL.Nat,
		'verifiedTicketsValue': IDL.Nat,
		'listingsCancelled': IDL.Nat,
		'batchTime': Time,
	});
	const Result_6 = IDL.Variant({
		'ok': RoundSettlementBatchReport,
		'err': IDL.Text,
	});
	const PrizeTypeUpdate = IDL.Variant({
		'BalanceUpdate': IDL.Record({ 'amount': IDL.Opt(IDL.Nat) }),
		'TicketUpdate': IDL.Record({ 'quantity': IDL.Opt(IDL.Nat) }),
		'RuneUpdate': IDL.Record({
			'tokenInfo': IDL.Opt(TokenInfo),
			'amount': IDL.Opt(IDL.Nat),
		}),
	});
	const Result_2 = IDL.Variant({
		'ok': IDL.Vec(TicketInfo),
		'err': IDL.Text,
	});
	const Result_1 = IDL.Variant({
		'ok': IDL.Record({
			'runeAmount': IDL.Nat,
			'transaction': BalanceTransaction,
			'transferId': IDL.Nat,
			'tokenName': IDL.Text,
		}),
		'err': IDL.Text,
	});
	return IDL.Service({
		'addAdmin': IDL.Func([IDL.Principal], [Result_9], []),
		'addBalancePrize': IDL.Func(
			[IDL.Text, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat],
			[Result_5],
			[],
		),
		'addRunePrize': IDL.Func(
			[
				IDL.Text,
				TokenInfo,
				IDL.Nat,
				IDL.Nat,
				IDL.Nat,
				IDL.Nat,
				IDL.Nat,
				IDL.Nat,
			],
			[Result_5],
			[],
		),
		'addScheduler': IDL.Func([IDL.Principal], [Result_9], []),
		'addTicketPrize': IDL.Func(
			[IDL.Text, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat],
			[Result_5],
			[],
		),
		'buyFromMarket': IDL.Func([IDL.Text], [Result_9], []),
		'buyTicketsWithBalance': IDL.Func(
			[IDL.Nat, IDL.Opt(IDL.Text)],
			[Result_12],
			[],
		),
		'cancelListing': IDL.Func([IDL.Text], [Result_9], []),
		'claimPrize': IDL.Func([IDL.Nat], [Result], []),
		'cleanupUsedTicketsBatch': IDL.Func([IDL.Nat], [Result_21], []),
		'cleanupUsedTicketsByRound': IDL.Func([IDL.Nat], [Result_20], []),
		'configureDividend': IDL.Func(
			[
				IDL.Nat,
				IDL.Bool,
				IDL.Nat,
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
			],
			[Result_19],
			[],
		),
		'createRound': IDL.Func(
			[
				IDL.Text,
				IDL.Opt(Time),
				IDL.Opt(Time),
				IDL.Bool,
				IDL.Bool,
				IDL.Bool,
				IDL.Bool,
				IDL.Opt(IDL.Text),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Bool),
			],
			[Result_4],
			[],
		),
		'disableDynamicPool': IDL.Func([IDL.Nat], [Result_9], []),
		'drawTicket': IDL.Func([IDL.Text], [Result_18], []),
		'drawTicketsBatch': IDL.Func([IDL.Vec(IDL.Text)], [Result_17], []),
		'enableDynamicPool': IDL.Func([IDL.Nat], [Result_5], []),
		'exchangeTicketsForPoints': IDL.Func([IDL.Vec(IDL.Text)], [Result_16], []),
		'getAvailablePrizes': IDL.Func([], [IDL.Vec(PrizeView)], ['query']),
		'getDividendPreview': IDL.Func([IDL.Nat], [Result_15], ['query']),
		'getDividendReport': IDL.Func(
			[IDL.Nat],
			[IDL.Opt(DividendSettlementReport)],
			['query'],
		),
		'getDynamicPoolStatus': IDL.Func([IDL.Nat], [Result_14], ['query']),
		'getFinancialSummary': IDL.Func(
			[StatisticsQueryScope],
			[FinancialSummary],
			['query'],
		),
		'getMyReferralInfo': IDL.Func([], [UserReferralInfo], ['query']),
		'getOrderById': IDL.Func([IDL.Nat], [IDL.Opt(MarketOrder)], ['query']),
		'getPoolContributionHistory': IDL.Func(
			[IDL.Nat],
			[IDL.Vec(PoolContributionRecord)],
			['query'],
		),
		'getPoolDistributionHistory': IDL.Func(
			[IDL.Nat],
			[IDL.Vec(PoolDistributionRecord)],
			['query'],
		),
		'getReferrerChain': IDL.Func(
			[IDL.Opt(IDL.Principal), IDL.Opt(IDL.Nat)],
			[IDL.Vec(IDL.Principal)],
			['query'],
		),
		'getRoundSettlementStats': IDL.Func([IDL.Nat], [Result_13], ['query']),
		'getRounds': IDL.Func(
			[IDL.Opt(RoundQueryFilter)],
			[IDL.Vec(Round)],
			['query'],
		),
		'getSystemConfig': IDL.Func(
			[IDL.Opt(SystemConfigType)],
			[SystemConfigResponse],
			['query'],
		),
		'getSystemControls': IDL.Func([], [SystemControls], ['query']),
		'getSystemStats': IDL.Func(
			[StatisticsQueryScope],
			[
				IDL.Record({
					'ticketStats': IDL.Record({
						'totalTicketsUsed': IDL.Nat,
						'totalTicketsIssued': IDL.Nat,
						'totalExchanges': IDL.Nat,
						'totalUsers': IDL.Nat,
					}),
					'prizeStats': IDL.Record({
						'totalPrizes': IDL.Nat,
						'totalStock': IDL.Nat,
						'totalRemaining': IDL.Nat,
						'lowStockPrizes': IDL.Vec(PrizeView),
					}),
					'lotteryStats': LotteryStats,
				}),
			],
			['query'],
		),
		'getTokenConfigs': IDL.Func(
			[IDL.Opt(IDL.Vec(IDL.Text))],
			[IDL.Vec(IDL.Tuple(IDL.Text, TokenConfig))],
			['query'],
		),
		'getTopUsersByDeposit': IDL.Func(
			[IDL.Nat],
			[IDL.Vec(TopUserData)],
			['query'],
		),
		'getUsedTicketsCleanupStats': IDL.Func(
			[],
			[
				IDL.Record({
					'settledRoundsCount': IDL.Nat,
					'byRound': IDL.Vec(IDL.Tuple(IDL.Nat, IDL.Text, IDL.Nat)),
					'totalUsedTickets': IDL.Nat,
				}),
			],
			['query'],
		),
		'getUserBalance': IDL.Func([IDL.Principal], [UserBalance], ['query']),
		'getUserDividendHistory': IDL.Func(
			[IDL.Opt(IDL.Principal)],
			[UserDividendHistory],
			['query'],
		),
		'getUserTickets': IDL.Func(
			[IDL.Principal, IDL.Opt(TicketFilter)],
			[IDL.Vec(TicketInfo)],
			['query'],
		),
		'getUserWithdrawStatus': IDL.Func(
			[IDL.Principal],
			[WithdrawStatus],
			['query'],
		),
		'grantTickets': IDL.Func(
			[IDL.Principal, IDL.Nat, IDL.Text],
			[Result_12],
			[],
		),
		'initRoundFinancial': IDL.Func([IDL.Nat], [Result_9], []),
		'isPointsExchangeEnabled': IDL.Func([], [IDL.Bool], ['query']),
		'listTicketForSale': IDL.Func([IDL.Text, IDL.Nat], [Result_9], []),
		'manageRound': IDL.Func([IDL.Nat, RoundManageAction], [Result_4], []),
		'processRuneTransfer': IDL.Func([Platform, IDL.Nat], [Result_11], []),
		'queryActiveOrders': IDL.Func(
			[
				MarketQueryScope,
				IDL.Opt(MarketFilterV2),
				IDL.Opt(IDL.Nat),
				Direction,
				IDL.Nat,
			],
			[PaginatedResult_4],
			['query'],
		),
		'queryCommissionRecords': IDL.Func(
			[CommissionQueryScope, IDL.Opt(CursorType), Direction, IDL.Nat],
			[PaginatedResult_6],
			['query'],
		),
		'queryMarketOrders': IDL.Func(
			[IDL.Bool, IDL.Opt(MarketFilter), IDL.Nat],
			[IDL.Vec(MarketOrder)],
			['query'],
		),
		'queryOperations': IDL.Func(
			[OperationQueryScope, IDL.Opt(IDL.Nat), Direction, IDL.Nat],
			[PaginatedResult_5],
			['query'],
		),
		'queryOrderHistory': IDL.Func(
			[
				MarketQueryScope,
				IDL.Opt(MarketFilterV2),
				IDL.Opt(IDL.Nat),
				Direction,
				IDL.Nat,
			],
			[PaginatedResult_4],
			['query'],
		),
		'queryPoints': IDL.Func(
			[PointsQueryScope, IDL.Bool],
			[PointsQueryResponse],
			['query'],
		),
		'queryReferralInfo': IDL.Func(
			[ReferralQueryScope, IDL.Opt(CursorType), Direction, IDL.Nat],
			[PaginatedResult_3],
			['query'],
		),
		'queryTransactions': IDL.Func(
			[TransactionQueryScope, IDL.Opt(IDL.Nat), Direction, IDL.Nat],
			[PaginatedResult_2],
			['query'],
		),
		'queryUserBalances': IDL.Func(
			[
				BalanceQueryScope,
				IDL.Opt(IDL.Text),
				Direction,
				IDL.Nat,
				IDL.Opt(BalanceFilter),
			],
			[PaginatedResult_1],
			['query'],
		),
		'queryWinRecords': IDL.Func(
			[
				WinRecordQueryScope,
				IDL.Opt(IDL.Nat),
				Direction,
				IDL.Nat,
				IDL.Opt(WinRecordFilter),
			],
			[PaginatedResult],
			['query'],
		),
		'recycleTicket': IDL.Func([IDL.Text], [Result_10], []),
		'refreshTicket': IDL.Func([IDL.Text], [Result_3], []),
		'removeRole': IDL.Func([IDL.Principal], [Result_9], []),
		'replenishStock': IDL.Func(
			[IDL.Nat, IDL.Nat, IDL.Opt(IDL.Text)],
			[Result_5],
			[],
		),
		'setLotteryStatus': IDL.Func([LotteryStatus], [Result_9], []),
		'setOperationToggle': IDL.Func(
			[OperationAction, IDL.Bool],
			[Result_9],
			[],
		),
		'setPointsExchangeEnabled': IDL.Func([IDL.Bool], [Result_9], []),
		'setTokenConfig': IDL.Func([TokenConfig], [Result_9], []),
		'settleDividend': IDL.Func([IDL.Nat], [Result_8], []),
		'settleRound': IDL.Func([IDL.Nat], [Result_7], []),
		'settleRoundTicketsBatch': IDL.Func([IDL.Nat, IDL.Nat], [Result_6], []),
		'updatePrize': IDL.Func(
			[
				IDL.Nat,
				IDL.Opt(IDL.Text),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Nat),
				IDL.Opt(PrizeTypeUpdate),
			],
			[Result_5],
			[],
		),
		'updateRound': IDL.Func(
			[
				IDL.Nat,
				IDL.Opt(IDL.Text),
				IDL.Opt(IDL.Opt(Time)),
				IDL.Opt(IDL.Opt(Time)),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Opt(IDL.Text)),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Nat),
				IDL.Opt(IDL.Bool),
				IDL.Opt(IDL.Bool),
			],
			[Result_4],
			[],
		),
		'verifyTicket': IDL.Func([IDL.Text], [Result_3], []),
		'verifyTicketsBatch': IDL.Func([IDL.Vec(IDL.Text)], [Result_2], []),
		'withdraw': IDL.Func([IDL.Nat], [Result_1], []),
		'withdrawRunes': IDL.Func(
			[IDL.Text, IDL.Principal, IDL.Nat, IDL.Nat8],
			[Result],
			[],
		),
	});
};
export const init = ({ IDL }) => { return []; };